import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { Roles } from '@enums/roles.enum';

@Injectable({
  providedIn: 'root'
})
export class TechnicalGuard implements CanActivate {

  constructor(private authenticationService: AuthenticationService, private router: Router) { }

  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authenticationService.isAccessTokenValid() && this.authenticationService.userHasRole(Roles.Technical)) {
      return true;
    }
    this.router.navigate(['/auth/login'], {
      queryParams: { returnUrl: state.url, message: 'Sie haben keinen Zugriff auf die technische Ansicht.' }
    });
    return false;
  }
}
